import { connect, MapStateToProps } from "react-redux";

import { EmptyMessageComponent, EmptyMessageComponentProps } from "@multiweb/reactComponents";
import { IAppState } from "@multiweb/types/react";
import { createGetEmptyMessageSelector } from "../../selectors";

export type EmptyMessageProps = {
    /** Unikátní klíč pro DataSource. */
    dataSourceKey: string;
};

type StateProps = Pick<EmptyMessageComponentProps, "emptyMessage">;

const createMapStateToProps: (
    state: IAppState,
    props: EmptyMessageProps
) => MapStateToProps<StateProps, EmptyMessageProps, IAppState> = () => {
    const getEmptyMessage = createGetEmptyMessageSelector();

    return (state, { dataSourceKey }) => ({
        emptyMessage: getEmptyMessage(state, dataSourceKey),
    });
};

export const EmptyMessage = connect(createMapStateToProps)(EmptyMessageComponent);
